export default __webpack_public_path__ + "static/peer2panel_logo-5093995a4b004b866b96bcae4aae3388.jpg";